// KB-3308: build-time flag that switches the location editor to a live-only data path
// (no `campLocationVersions` snapshots; publish/unpublish flip visibility only; unsaved
// edits kept in a browser-side draft). Default OFF — off is byte-identical to today.
//
// Read the env at CALL TIME, never as a module-level constant: a constant captured at import
// cannot be overridden by `vi.stubEnv`, which makes "flag off" (and every flag-on branch)
// untestable. See `src/lib/sentry-init.test.ts` for the stubEnv pattern this enables.
//
// The value is baked in at build time by `.github/workflows/react-admin-cicd.yml`; turning it
// on in production is an out-of-system action (workflow env edit + redeploy), not a runtime
// toggle. See KB-3308 rulings 3 and 4.
export const LOCATION_EDIT_LIVE_SOURCE_ENV = "VITE_LOCATION_EDIT_LIVE_SOURCE";

/**
 * True when the location editor should read and write the live `campLocations` doc only,
 * with no `campLocationVersions` snapshot writes. Reads `import.meta.env` at call time.
 *
 * Accepts the string `"true"` (case-insensitive) or `"1"` as on; anything else is off.
 */
export const isLocationEditLiveSource = (): boolean => {
  const raw = import.meta.env[LOCATION_EDIT_LIVE_SOURCE_ENV];
  if (typeof raw !== "string") return false;
  const normalized = raw.trim().toLowerCase();
  return normalized === "true" || normalized === "1";
};
